export default [
  {
    title: 'Inventory',
    customIcon: 'InventorySVG',
    children: [
      {
        title: 'Privilege',
        route: 'inventory-privilege-list',
        path: '/inventory/privilege/list',
      },
    ],
  },
];
